import React from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={12} className="text-center">
              {new Date().getFullYear()} © Subhosting.
            </Col>
            {/* <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Design & Develop by Team Trust
              </div>
            </Col> */}
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
